/** Limite por arquivo nas APIs de Documento do PNCP (Manual de Integração v2.4, seção 5.16). */
export const PNCP_DOCUMENT_UPLOAD_MAX_MB = 30;
export const PNCP_DOCUMENT_UPLOAD_LIMIT_BYTES = PNCP_DOCUMENT_UPLOAD_MAX_MB * 1024 * 1024;

export const PNCP_DOCUMENT_UPLOAD_TOOLTIP = `Ao carregar o arquivo, ele será automaticamente enviado. Tamanho máximo ${PNCP_DOCUMENT_UPLOAD_MAX_MB}MB`;

export function getPncpDocumentUploadSizeErrorMessage() {
  return `Insira um arquivo com até ${PNCP_DOCUMENT_UPLOAD_MAX_MB}MB`;
}

export function isWithinPncpDocumentUploadLimit(fileSize) {
  return Number(fileSize) <= PNCP_DOCUMENT_UPLOAD_LIMIT_BYTES;
}
